import React, { useEffect } from "react";
import "./With_Dep_Ammout_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightArrowLeft, faWallet } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { GETAuthLogin } from "../../../../features/auth/Slice";
import { formatAmount } from "../../../../utils/common";

function With_Dep_Ammout_card() {

  const dispatch = useDispatch()
  const user = useSelector((state => state.auth));

  useEffect(() => { dispatch(GETAuthLogin()) }, [dispatch]);
  return (
    <>
      <section className="With_Dep_Ammout_card">
        <div className="bg_holder_holder">
          <div className="bg_img">
            <img
              src="/assets/images/withdraw_Deposite/With_Dep_Ammout_card/bg.png"
              alt="card background"
              className="card_background_img"
            />

            <div className="card_content">
              <div className="balance_top">
                <span className="balance_icon"><FontAwesomeIcon icon={faWallet} /></span>
                <span>Available balance</span>
              </div>

              <div className="balance_amount">
                {formatAmount(user?.data?.Wallet?.amount)}
                <span className="refresh_icon" onClick={() => window.location.reload()}
                ><FontAwesomeIcon icon={faArrowRightArrowLeft} /></span>
              </div>

              <div className="card_dots">**** &nbsp;&nbsp; ****</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default With_Dep_Ammout_card;
